import React, { useEffect, useState } from 'react';
import './style.scss';
import { Owner } from '../../components/Owner';

import firebase from '../../firebase';
import { PrimaryButton } from '../../components/commons/Button';
import { Modal } from '../../components/commons/Modal';
import { RoundButton } from '../../components/commons/RoundButton/RoundButton';

function convertSecondstoTime(given_seconds) {
  var dateObj = new Date(given_seconds * 1000);
  var hours = dateObj.getUTCHours();
  var minutes = dateObj.getUTCMinutes();
  var seconds = dateObj.getSeconds();
  return hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0') + ':' + seconds.toString().padStart(2, '0');
}

export const VideoList = () => {
  const [videos, setVideos] = useState([]);
  const [showModal, setModal] = useState(false);
  const [url, setUrl] = useState();
  const [name, setName] = useState();
  var db = firebase.firestore();

  useEffect(() => {
    const v = [];
    const unsubscribe = db
      .collection('videos')
      .get()
      .then(function (querySnapshot) {
        const videos = [];
        querySnapshot.forEach(function pushToVideos(doc) {
          videos.push({ id: doc.id, ...doc.data() });
        });

        setVideos(videos);
      });

    setVideos(v);

    return unsubscribe;
  }, [setVideos]);

  const createNewVideo = (data) => {
    const newVideoDoc = db.collection('videos').doc();
    newVideoDoc
      .set({
        ...data,
        created_at: firebase.firestore.Timestamp.now(),
      })
      .then(function (d) {
        console.log('Document successfully written!', newVideoDoc);
        window.location.href = `/editor/${newVideoDoc.id}`;
      });
  };

  return (
    <>
      <Modal show={showModal} onClose={setModal.bind(undefined, false)}>
        <div className={'new-modal'}>
          <h2>New Video</h2>
          <input
            placeholder={'Name'}
            onInput={(e) => {
              setName(e.target.value);
            }}></input>
          <input
            type={'url'}
            placeholder={'Video URL'}
            onInput={(e) => {
              setUrl(e.target.value);
            }}></input>
          <PrimaryButton
            disabled={!(url && name)}
            onClick={createNewVideo.bind(this, {
              username: 'SUDO',
              config: JSON.stringify({ elements: [] }),
              url,
              name,
            })}>
            Next
          </PrimaryButton>
        </div>
      </Modal>
      <div className='listing-page'>
        <div className='options'>
          <PrimaryButton onClick={setModal.bind(undefined, true)}>Create New +</PrimaryButton>
        </div>
        <div className={'video-list'}>
          {videos.map((video) => (
            <div
              className={'item'}
              key={video.id}
              onClick={() => {
                window.location.href = `/player/${video.id}`;
              }}>
              <div className={'info'}>
                <div className={'video-name'}>{video.name}</div>
                <Owner name={video.username} date={video.created_at.toDate().toDateString()} />
              </div>
              <div className={'actions'}>
                <div className={'action'}>
                  <RoundButton
                    icon='/icons/edit.svg'
                    onClick={(event) => {
                      window.location.href = `/editor/${video.id}`;
                      event.preventDefault();
                      event.stopPropagation();
                    }}
                  />
                </div>
                <div className={'action'}>
                  <RoundButton
                    tooltip='Copied URL'
                    icon='/icons/share.svg'
                    onClick={(event) => {
                      var textarea = document.createElement('textarea');
                      textarea.style.position = 'fixed';
                      textarea.style.top = '-1px';
                      textarea.style.left = '-1px';
                      textarea.style.width = '1px';
                      textarea.style.height = '1px';
                      textarea.style.opacity = 0;
                      textarea.style.pointerEvents = 'none';
                      textarea.value = window.location.href + `player/${video.id}`;
                      document.body.appendChild(textarea);
                      textarea.select();

                      try {
                        var copiedURL = document.execCommand('copy');
                        if (copiedURL) {
                        } else {
                          console.debug('Copy failed');
                        }
                      } catch (err) {
                        console.debug('Copy failed', err);
                      }

                      document.body.removeChild(textarea);
                      event.preventDefault();
                      event.stopPropagation();
                    }}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};
